export const daySummaryDummy = {
  time: 32400,
  focus: 14400,
  activities: 500,
};
